import { PoolIcon } from './PoolIcon';

/**
 * author: Austin Andrews
 * id F42C2F0C-BEFC-46EB-A46C-665032BD6641
 * name pool
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pool.svg
 * tags
 * - Places 
 * - Home Automation 
 */
export const SwimmingPoolIcon = PoolIcon;
export default SwimmingPoolIcon